// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CabCalf, CabCalfSchema } from 'api/gen/CabCalf';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PageMetadata, PageMetadataSchema } from 'api/gen/PageMetadata';

const requiredPart = t.interface({
  content: t.union([t.array(CabCalfSchema), t.null]),
  page: t.union([PageMetadataSchema, t.null]),
});

export const PagedModelCabCalfSchema = excess(requiredPart);

export interface PagedModelCabCalf extends t.TypeOf<typeof PagedModelCabCalfSchema> {}
